import {
    Box,
    Stack,
    Heading,
    Text,
    Divider,
    Spacer,
    SimpleGrid,
    Spinner
} from '@chakra-ui/react'
import { PROTECTED_ROUTES } from '@/shared/config/routes'
import { ProtectedPage } from '@/shared/components/ProtectedPage'
import AlternativeContactPage from '@/modules/parent/alternative-contact-page/AlternativeContactPage'
import { useAlternativeContactList } from '@/modules/parent/alternative-contact-page/useAlternativeContactList'
import { useAuth } from '@/shared/context/AuthContext'
import AlternativeContactUserCard from '@/modules/parent/alternative-contact-page/AlternativeContactUserCard'

export default function AlternativeContactList() {
    const { user } = useAuth()
    const { alternativeContact, loading } = useAlternativeContactList(
        user?.parent?._id || ''
    )

    if (loading) return <Spinner size={'xl'} />

    return (
        <ProtectedPage routeConfig={PROTECTED_ROUTES['/user/parent/alternative-contact']}>
            <Box
                minH={['container.sm', 'container.md']}
                borderRadius={4}
                bg={'white'}
                p={8}
            >
                <Stack direction={['column', 'row']} align={'center'}>
                    <Box>
                        <Heading
                            fontSize={{ base: '3xl', md: 'xxl' }}
                            fontWeight={'bold'}
                        >
                            Guardian Contact
                        </Heading>
                        <Text
                            color={'gray.600'}
                            mb="4"
                            fontSize={{ base: 'sm', sm: 'lg' }}
                        >
                            You see your guardian contact and their details here
                        </Text>
                    </Box>
                    <Spacer />
                    <Box>
                        <AlternativeContactPage />
                    </Box>
                </Stack>

                <Divider my={4} />
                <SimpleGrid
                    spacing={3}
                    templateColumns="repeat(auto-fill, minmax(300px, 1fr))"
                >
                    {alternativeContact?.length
                        ? alternativeContact.map((user) => (
                              <AlternativeContactUserCard
                                  alternativeContact={user}
                                  key={user._id}
                              />
                          ))
                        : null}
                </SimpleGrid>
            </Box>
        </ProtectedPage>
    )
}
